import styled from '@tanium/react-emotion-9';

export const Overlay = styled('div', { shouldForwardProp: (p) => p !== 'width' && p !== 'height' })<{
  width: number;
  height: number;
}>(({ width, height }) => ({
  position: 'absolute',
  width,
  height,
  top: 0,
  left: 0,
  overflow: 'hidden',
  pointerEvents: 'none',
  '> *': {
    pointerEvents: 'auto',
  },
}));
